const gradients = {
  primary: {
    radial: `radial-gradient(50% 109.37% at 50% 50%, #0046FF 0%, #0008E2 100%)`,
    right: `linear-gradient(270deg, #0046FF 0%, #0008E2 100%);`,
    left: `linear-gradient(90deg, #0046FF -1.75%, #0008E2 100%);`,
    down: `linear-gradient(180deg, #0008E2 0%, #0046FF 100%);`,
    up: `linear-gradient(153.44deg, #0046FF 16.67%, #0008E2 83.33%);`,
    angleUp: `linear-gradient(45deg, #0008E2 0%, #0046FF 100%);`,
    angleDown: `linear-gradient(315deg, #0046FF 0%, #0008E2 100%);`,
  },
  secondary: {
    radial: `radial-gradient(50% 109.37% at 50% 50%, #0008E2 0%, #00047A 100%);`,
    right: `linear-gradient(270deg, #0008E2 0%, #00047A 100%);`,
    left: `linear-gradient(90deg, #0008E2 -1.75%, #00047A 100%);`,
    down: `linear-gradient(180deg, #00047A 0%, #0008E2 100%);`,
    up: `linear-gradient(153.44deg, #0008E2 16.67%, #00047A 83.33%);`,
    angleUp: `linear-gradient(251.98deg, #0008E2 0%, #00047A 100%);`,
    angleDown: `linear-gradient(135deg, #00047A 0%, #0008E2 100%);`,
  },
  tertiary: {
    radial: `radial-gradient(50% 109.37% at 50% 50%, #00047A 0%, #000347 100%);`,
    right: `linear-gradient(270deg, #00047A 0%, #000347 100%);`,
    left: `linear-gradient(90deg, #00047A -1.75%, #000347 100%);`,
    down: `linear-gradient(180deg, #000347 0%, #00047A 100%);`,
    up: `linear-gradient(153.44deg, #00047A 16.67%, #000347 83.33%);`,
    angleUp: `linear-gradient(45deg, #000347 0%, #00047A 100%);`,
    angleDown: `linear-gradient(135deg, #00047A 0%, #000347 100%);`,
  },
  quaternary: {
    radial: `radial-gradient(50% 109.37% at 50% 50%, #667085 0%, #475467 100%);`,
    right: `linear-gradient(90deg, #475467 0%, #667085 100%);`,
    left: `linear-gradient(45deg, #344054 0%, #475467 100%);`,
    down: `linear-gradient(45deg, #1D2939 0%, #475467 100%);`,
    up: `linear-gradient(63.44deg, #1D2939 16.72%, #475467 83.39%);`,
    angleUp: `linear-gradient(26.57deg, #1D2939 8.33%, #344054 91.67%);`,
    angleDown: `linear-gradient(45deg, #101828 0%, #475467 100%);`,
  },
};

export default gradients;
